import '../scss/components/search-autocomplete.scss';
import { ensureArray } from './utils/ensure-array.js';

const searchFormEl = document.querySelector('.js-search-autocomplete');
let searchResults = {};
let searchTerm = "";
let searchAbortController = null;

if (searchFormEl) {
    const searchInputEl = searchFormEl.querySelector('.js-search-autocomplete_input');
    const locationSearch = document.location.search;
    const searchParams = new URLSearchParams(locationSearch);
    if (searchParams.has('q')) {
        searchTerm = searchParams.get('q').toLowerCase();
        searchInputEl.value = searchTerm;
        searchFormEl.classList.add('has-value');
    }

    const searchInputRemoveEl = searchFormEl.querySelector('.js-search-autocomplete_remove-btn');
    searchInputRemoveEl.addEventListener('click', (event) => {
        searchInputEl.value = '';
        searchFormEl.classList.remove('has-value');
    });

    searchInputEl.addEventListener('input', async (event) => {
        searchResults = {};
        searchTerm = event.currentTarget.value.toLowerCase();

        if (searchAbortController) {
            searchAbortController.abort();
            searchAbortController = null;
        }

        if (searchTerm.length <= 0) {
            const resultsListEl = searchFormEl.querySelector('.js-search-autocomplete_results-list');
            if (resultsListEl) resultsListEl.remove();
            searchFormEl.classList.remove('has-value');
        }

        if (searchTerm.length > 1) {
            await fetchSearchResults({"query": searchTerm, "size": 4})
                .then((suggestions) => {
                    let searchResultsListEl = searchFormEl.querySelector('.js-search-autocomplete_results-list');
                    if (!searchResultsListEl) {
                        searchResultsListEl = document.createElement('ul');
                        searchResultsListEl.classList.add('search-autocomplete_results-list', 'js-search-autocomplete_results-list');
                    } else {
                        searchResultsListEl.innerHTML = '';
                    }

                    if(!searchFormEl.classList.contains('has-value')) searchFormEl.classList.add('has-value');

                    const searchResultsItem = createSearchResultItem();
                    searchResultsListEl.appendChild(searchResultsItem);

                    if (Array.isArray(suggestions) && suggestions.length > 0) {
                        suggestions.forEach((suggest) => {
                            const searchResultsItem = createSearchResultItem(suggest);
                            searchResultsListEl.appendChild(searchResultsItem);
                        });
                    } else {
                        const listItem = document.createElement('li');
                        listItem.classList.add('search-autocomplete_result');
                        listItem.innerHTML = `<span>Keine Ergebnisse</span>`;
                        searchResultsListEl.appendChild(listItem);
                    }
                    searchFormEl.appendChild(searchResultsListEl);
                });
        }
    });

    searchInputEl.addEventListener('focusout', (event) => {
        const resultsListEl = searchFormEl.querySelector('.js-search-autocomplete_results-list');
        setTimeout(() => {
            if (resultsListEl) resultsListEl.remove();
        }, 200);
    });

    async function fetchSearchResults(searchTerm) {
        try {
            if (searchAbortController) {
                searchAbortController.abort();
                searchAbortController = null;
            }
            searchAbortController = new AbortController();
            return await fetch('/api/aps/suggestion', {
                signal: searchAbortController.signal,
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(searchTerm),
            })
                .then(response => response.json())
                .then(data => {
                    if (searchAbortController) {
                        searchAbortController = null;
                    }
                    if (data.descriptors && data.descriptors.descriptor) {
                        return ensureArray(data.descriptors.descriptor);
                    }
                    return [];
                });
        } catch (error) {
            if (error && error.name === 'AbortError') return;
            console.error(error);
        }
    }

    function createSearchResultItem(result) {
        const listItem = document.createElement('li');
        listItem.classList.add('search-autocomplete_result');
        listItem.innerHTML = `
            <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0a4.5 4.5 0 1 1-.01-8.99A4.5 4.5 0 0 1 9.5 14z" style="fill: currentcolor;"></path>
            </svg>
        `;
        if (!!result) {
            const [term, rest] = result.value.split(searchTerm);
            listItem.dataset.value = result.value;
            listItem.innerHTML += `
            <span data-user-value="true">${searchTerm || ''}</span>
            <span data-suggested-value="true">${rest || ''}</span>
        `;
        } else {
            listItem.dataset.value = searchTerm;
            listItem.innerHTML += `
                <span>Nach "${searchTerm}" suchen</span>
            `;
        }
        listItem.addEventListener('click', (event) => {
            event.preventDefault();
            const result = event.currentTarget;
            searchInputEl.value = result.dataset.value;
            searchFormEl.submit();
        });
        return listItem;
    }
}
